import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Tulare',
  description: 'Licensed electrician serving Tulare, CA. C-10 certified electrical contractor for residential and commercial electrical work in Tulare and Tulare County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Tulare',
    addressRegion: 'CA',
    postalCode: '93274',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.2077', longitude: '-119.3473' },
  url: 'https://electriciansolutionsfresno.com/areas/tulare',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Tulare', '@id': 'https://en.wikipedia.org/wiki/Tulare,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrical services in Tulare, CA?',
    a: 'Yes! Electrician Solutions Fresno serves all of Tulare, CA with licensed C-10 electrical contractor services. From the World Ag Expo grounds to residential neighborhoods throughout the city, our certified Tulare electricians handle all residential, commercial, and agricultural electrical projects.',
  },
  {
    q: 'Can you handle agricultural electrical work in Tulare County?',
    a: 'Absolutely. Tulare County is the nation\'s top agricultural county and we specialize in farm electrical systems including pump station wiring, three-phase power installations, cold storage refrigeration circuits, packing shed electrical, and solar-ready agricultural panel upgrades.',
  },
  {
    q: 'How fast can you respond to electrical emergencies in Tulare?',
    a: 'We provide 24/7 emergency electrical services in Tulare with typical response times of 60–90 minutes. For critical agricultural operations, we prioritize rapid response to minimize downtime and crop loss.',
  },
  {
    q: 'Do you install commercial electrical systems in Tulare?',
    a: 'Yes. We handle full commercial electrical installations in Tulare including the Tulare Industrial Park, Prosperity Avenue corridor businesses, retail stores, and the medical district on Bardsley Avenue.',
  },
  {
    q: 'What does a panel upgrade cost in Tulare?',
    a: 'Panel upgrades in Tulare typically range from $1,500 for a standard 200A upgrade to $4,500+ for larger service upgrades. All prices include the City of Tulare permit, labor, materials, and final inspection.',
  },
  {
    q: 'Can you install backup power systems for Tulare farms?',
    a: 'Yes. We install backup generator hookups, battery storage systems, and standby power solutions for Tulare County farms and agricultural operations to ensure continuous operation during PG&E PSPS events.',
  },
];

const TularePage = () => (
  <AreaTemplate
    area="Tulare"
    areaSlug="tulare"
    state="CA"
    county="Tulare County"
    population="68,000+"
    description="Electrician Solutions Fresno serves all of Tulare, CA with expert C-10 licensed electrical services. As home to the World Ag Expo and one of California's most productive agricultural regions, Tulare demands an electrical contractor with expertise in both residential and agricultural systems. Our certified Tulare electricians deliver reliable electrical solutions for homes, businesses, and farms throughout Tulare County."
    neighborhoods={['Downtown Tulare', 'North Tulare', 'East Tulare', 'West Tulare', 'Prosperity Ave Corridor', 'Bardsley Medical District', 'Tulare Industrial Park', 'Tipton Area']}
    nearbyAreas={[
      { name: 'Visalia', slug: 'visalia' },
      { name: 'Hanford', slug: 'hanford' },
      { name: 'Porterville', slug: 'porterville' },
      { name: 'Dinuba', slug: 'dinuba' },
      { name: 'Fresno', slug: 'fresno' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/b41a48281d232e5cf5a3c1a7001dfe35.jpg"
    heroImageAlt="Licensed Electrician in Tulare CA"
    teamImage="https://readdy.ai/api/search-image?query=Certified%20electrician%20team%20in%20professional%20uniforms%20standing%20in%20front%20of%20Tulare%20California%20agricultural%20landscape%20with%20farm%20fields%20irrigation%20channels%20and%20blue%20sky%20showing%20deep%20roots%20in%20the%20Central%20Valley%20farming%20community&width=800&height=600&seq=tulare_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Tulare CA"
    schema={schema}
  />
);

export default TularePage;
